import { isInHomeWork } from '@/utils/tools';
import { isAndroid, inApp } from '@k/system';
import { Ref, onBeforeMount, onMounted, ref } from '@vue/composition-api';
import { hybrid } from 'hybrid-sdk-common';

const __status_bar_height_key__ = Symbol('__status_bar_height_key__');

export const useStatusBarHeight = (): Ref<number> => {
  const statusBarHeightKeyToString = __status_bar_height_key__.toString();
  // 从缓存里面同步获取状态栏高度更快，防止闪一下的问题
  let localStatusBarHeight = 0;
  try {
    const localValue = localStorage.getItem(statusBarHeightKeyToString) || '0';
    localStatusBarHeight = parseInt(localValue, 10);
  } catch (error) {
    console.error('localStorage parse error', error);
  }

  // 全屏状态下，设置标题栏组件的padding-top
  const _statusBarHeight = ref(localStatusBarHeight);

  const setLocalHeight = (key: string, height: number) => {
    localStorage.setItem(key, '' + height);
  };

  const setPaddingTop = (height: number) => {
    const theHeader: HTMLDivElement | null = document.querySelector('.the-header');
    if (isAndroid && theHeader) {
      theHeader.style.setProperty('padding-top', `${height}px`);
    }
  };

  onBeforeMount(async () => {
    try {
      if (inApp) {
        const { statusBarHeight } = await hybrid('common');
        _statusBarHeight.value = statusBarHeight;
      } else if (isInHomeWork) {
        const { height } = await hybrid('webviewTopHeight');
        _statusBarHeight.value = height / (window.devicePixelRatio || 1);
      } else {
        _statusBarHeight.value = 0;
      }
      setLocalHeight(statusBarHeightKeyToString, _statusBarHeight.value);
    } catch (error) {
      console.error('action error', error);
    } finally {
      setPaddingTop(_statusBarHeight.value);
    }
  });

  onMounted(() => {
    if (_statusBarHeight.value != 0) {
      setPaddingTop(_statusBarHeight.value);
    }
  });
  return _statusBarHeight;
};
